import { BuilderTypes } from "./BuilderTypes";
import { BuilderStorageItem } from "./BuilderStorageItem";

export class BuilderStorage extends BuilderStorageItem {
    builderData: object = {};

    inputDefinitionId?: string;
    outputDefinitionId?: string;

    constructor(builderStorageId: string, builderType: BuilderTypes, name: string) {
        super(builderStorageId, builderType, name);
    }
}
